// Sign Up
export const SIGN_UP_REQUEST = 'SIGN_UP_REQUEST';
export const SIGN_UP_SUCCESS = 'SIGN_UP_SUCCESS';
export const SIGN_UP_FAILURE = 'SIGN_UP_FAILURE';

// Sign In
export const SIGN_IN_REQUEST = 'SIGN_IN_REQUEST';
export const SIGN_IN_SUCCESS = 'SIGN_IN_SUCCESS';
export const SIGN_IN_FAILURE = 'SIGN_IN_FAILURE';

// Initial Firebase session reconciliation
export const AUTH_STATUS_RESOLVED = 'AUTH_STATUS_RESOLVED';

// Logout
export const LOGOUT = 'LOGOUT';

// Clear Errors
export const CLEAR_ERRORS = 'CLEAR_ERRORS';

// Update Profile
export const UPDATE_PROFILE_REQUEST = 'UPDATE_PROFILE_REQUEST';
export const UPDATE_PROFILE_SUCCESS = 'UPDATE_PROFILE_SUCCESS';
export const UPDATE_PROFILE_FAILURE = 'UPDATE_PROFILE_FAILURE';

// Forgot Password
export const FORGOT_PASSWORD_REQUEST = 'FORGOT_PASSWORD_REQUEST';
export const FORGOT_PASSWORD_SUCCESS = 'FORGOT_PASSWORD_SUCCESS';
export const FORGOT_PASSWORD_FAILURE = 'FORGOT_PASSWORD_FAILURE';

// Fetch Me (backend-sourced profile + role + emailVerified)
export const FETCH_ME_REQUEST = 'FETCH_ME_REQUEST';
export const FETCH_ME_SUCCESS = 'FETCH_ME_SUCCESS';
export const FETCH_ME_FAILURE = 'FETCH_ME_FAILURE';

// Update Me (backend-sourced)
export const UPDATE_ME_REQUEST = 'UPDATE_ME_REQUEST';
export const UPDATE_ME_SUCCESS = 'UPDATE_ME_SUCCESS';
export const UPDATE_ME_FAILURE = 'UPDATE_ME_FAILURE';

// Change Email
export const CHANGE_EMAIL_REQUEST = 'CHANGE_EMAIL_REQUEST';
export const CHANGE_EMAIL_SUCCESS = 'CHANGE_EMAIL_SUCCESS';
export const CHANGE_EMAIL_FAILURE = 'CHANGE_EMAIL_FAILURE';

// Change Password
export const CHANGE_PASSWORD_REQUEST = 'CHANGE_PASSWORD_REQUEST';
export const CHANGE_PASSWORD_SUCCESS = 'CHANGE_PASSWORD_SUCCESS';
export const CHANGE_PASSWORD_FAILURE = 'CHANGE_PASSWORD_FAILURE';

// Revoke Sessions
export const REVOKE_SESSIONS_REQUEST = 'REVOKE_SESSIONS_REQUEST';
export const REVOKE_SESSIONS_SUCCESS = 'REVOKE_SESSIONS_SUCCESS';
export const REVOKE_SESSIONS_FAILURE = 'REVOKE_SESSIONS_FAILURE';

// Refresh Claims (role/emailVerified update from server-side change)
export const REFRESH_CLAIMS_SUCCESS = 'REFRESH_CLAIMS_SUCCESS';

// Resend Verification
export const RESEND_VERIFICATION_REQUEST = 'RESEND_VERIFICATION_REQUEST';
export const RESEND_VERIFICATION_SUCCESS = 'RESEND_VERIFICATION_SUCCESS';
export const RESEND_VERIFICATION_FAILURE = 'RESEND_VERIFICATION_FAILURE';
